import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router-dom'
import { Page } from '~/components/Page'
import { SignupForm } from '../components'

export const SignupPage = () => {
    const { t } = useTranslation()
    return (
        <Page title='LOGIN' header='LOGIN'>
            <section className='animate-fade-in px-8 w-full max-w-4xl mx-auto flex flex-col items-center gap-y-8 text-xl text-center font-bold py-16 lg:py-24'>
                <header className='self-center text-4xl uppercase font-black text-center lg:text-5xl'>
                    {t('auth.layout_header')}
                </header>
                <div className='font-semibold'>{t('auth.signup_header')}.</div>
                <div className='grid grid-cols-2 gap-1 w-full text-base md:text-xl whitespace-nowrap'>
                    <NavLink
                        to='/signup'
                        className='p-4 hover:outline uppercase'
                        style={{ background: 'linear-gradient(142deg,#03CEFF 0%,#C91FFF 100%)' }}
                    >
                        {t('auth.signup')}
                    </NavLink>
                    <NavLink
                        to='/login'
                        className='p-4 hover:outline uppercase'
                        style={{ background: 'linear-gradient(140deg,#000 0%,rgba(0,0,0,0.00) 100%)' }}
                    >
                        {t('auth.login')}
                    </NavLink>
                </div>
                <SignupForm />
                <div>
                    {t('auth.already_have_account')}?{' '}
                    <NavLink to='/login' className='underline hover:no-underline'>
                        {t('auth.login')}.
                    </NavLink>
                </div>
                <div>
                    {t('auth.forgot_password')}?{' '}
                    <NavLink to='/password-reset' className='underline hover:no-underline'>
                        {t('auth.reset_password')}.
                    </NavLink>
                </div>
            </section>
        </Page>
    )
}
